import { Menu, X } from 'lucide-react';
import { useState, useEffect } from 'react';
import { Button } from './ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const whatsappUrl = 'https://api.whatsapp.com/send?phone=5514998053885&text=Oi!%20Vim%20pelo%20site%20e%20gostaria%20de%20falar%20com%20um%20especialista';

  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? 'hidden' : '';
    const onKeyDown = (e) => {
      if (e.key === 'Escape' && mobileMenuOpen) setMobileMenuOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [mobileMenuOpen]);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const handleWhatsAppClick = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'whatsapp_click', click_location: 'header' });
    window.open(whatsappUrl, '_blank');
    setMobileMenuOpen(false);
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center">
              <img
                src="/images/logohorizontal.webp"
                alt="Way2Go"
                width="160"
                height="36"
                loading="eager"
                decoding="async"
                className="h-8 md:h-9 w-auto"
              />
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-8">
              <button onClick={() => scrollToSection('benefits')} className="text-gray-700 hover:text-way2go-accent transition-colors font-medium">
                Diferenciais
              </button>
              <button onClick={() => scrollToSection('methodology')} className="text-gray-700 hover:text-way2go-accent transition-colors font-medium">
                Método CAMINHO
              </button>
              <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-way2go-accent transition-colors font-medium">
                Depoimentos
              </button>
              <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-way2go-accent transition-colors font-medium">
                FAQ
              </button>
              <Button
                onClick={handleWhatsAppClick}
                className="bg-way2go-accent hover:bg-orange-600 text-white font-semibold shadow-lg hover:shadow-xl transition-all"
                style={{
                  padding: '12px 24px',
                  fontWeight: 700
                }}
              >
                Agendar Sessão
              </Button>
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(true)}
              className="md:hidden text-way2go-primary"
              aria-label="Abrir menu"
            >
              <Menu size={28} />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu — full-screen solid overlay */}
      <div
        className={`fixed inset-0 z-[60] bg-[#0a0a0a] flex flex-col items-center justify-center md:hidden transition-opacity duration-300 ${
          mobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'
        }`}
      >
        {/* Close button */}
        <button
          onClick={() => setMobileMenuOpen(false)}
          className="absolute top-5 right-4 text-white"
          aria-label="Fechar menu"
        >
          <X size={28} />
        </button>

        <nav className={`flex flex-col items-center gap-8 transition-transform duration-300 ${
          mobileMenuOpen ? 'translate-y-0' : 'translate-y-5'
        }`}>
          <button onClick={() => scrollToSection('benefits')} className="text-white text-2xl font-semibold hover:text-way2go-accent transition-colors">
            Diferenciais
          </button>
          <button onClick={() => scrollToSection('methodology')} className="text-white text-2xl font-semibold hover:text-way2go-accent transition-colors">
            Método CAMINHO
          </button>
          <button onClick={() => scrollToSection('testimonials')} className="text-white text-2xl font-semibold hover:text-way2go-accent transition-colors">
            Depoimentos
          </button>
          <button onClick={() => scrollToSection('faq')} className="text-white text-2xl font-semibold hover:text-way2go-accent transition-colors">
            FAQ
          </button>
          <Button
            onClick={handleWhatsAppClick}
            className="bg-way2go-accent hover:bg-orange-600 text-white font-semibold shadow-lg hover:shadow-xl transition-all mt-4"
            style={{
              padding: '16px 32px',
              fontWeight: 700,
              fontSize: '1.125rem'
            }}
          >
            Agendar Sessão
          </Button>
        </nav>
      </div>
    </>
  );
};

export default Header;
